import { render, staticRenderFns } from "./AddDomainDialog.vue?vue&type=template&id=67e5ffec&scoped=true"
import script from "./AddDomainDialog.vue?vue&type=script&lang=js"
export * from "./AddDomainDialog.vue?vue&type=script&lang=js"
import style0 from "./AddDomainDialog.vue?vue&type=style&index=0&id=67e5ffec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e5ffec",
  null
  
)

export default component.exports